import axios from "axios";
import { timedReject } from "../forms/helper";
import { BIFAuthUser } from "./types";

const authorizationUrl = `${process.env.REACT_APP_BIF_ENDPOINT_AUTH}`;
export const storageId = "BifAuthUser";

export const requestVerify = (email: string, pin: string) => {
    return Promise.race([
        axios
            .post(authorizationUrl, {
                email: email,
                pin: pin
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                return response;
            }),
        timedReject(20000, "API request timed out")
    ]);
};

const getStorage = (type = 'temporary') => type === 'persistent' ? localStorage : sessionStorage;

export const loginUser = (
    user: {
        email: string;
        pin: string;
        token: string;
    },
    expirationInMinutes?: string
) => {
    const minutes = expirationInMinutes && !isNaN(Number(expirationInMinutes))
        ? Number(expirationInMinutes)
        : 10;
    const now = Date.now();
    const expiry = now + (minutes * 60 * 1000);

    const userData: BIFAuthUser = {
        ...user,
        expiry: expiry
    };
    getStorage().setItem(storageId, JSON.stringify(userData));
};

export const logoutUser = () => {
    getStorage().removeItem(storageId);
};

export const getLoggedInUser = () => {
    const userStr = getStorage().getItem(storageId);

    if (!userStr) return null;

    const user: BIFAuthUser = JSON.parse(userStr);
    const now = Date.now();

    // Remove session if expired
    if (now > user.expiry) {
        logoutUser();
        return null;
    }
    return user;
};
